import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ConfirmDialog,
  EditIcon,
  IconButton,
  List,
  ListItem,
  ListSeparator,
  Menu,
  TrashIcon,
  TreeDotsIcon,
} from "@activecollab/components";
import PropTypes from "prop-types";
import { useDeleteWebhookIntegrationMutation } from "~/repository";
import { WebhookFormDialog } from "./WebhookFormDialog";

export const WebhookIntegrationOptions = ({ integration }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const deleteWebhookMutation = useDeleteWebhookIntegrationMutation();

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  const handleOpenEdit = useCallback(() => setOpenEditDialog(true), []);
  const handleCloseEdit = useCallback(() => {
    setOpenEditDialog(false);
    setOpen(false);
  }, []);

  const handleOpenDelete = useCallback(() => setOpenDeleteDialog(true), []);
  const handleCloseDelete = useCallback(() => {
    setOpenDeleteDialog(false);
    setOpen(false);
  }, [setOpenDeleteDialog]);

  const handleDelete = useCallback(() => {
    deleteWebhookMutation.mutate(
      { id: integration.id },
      {
        onSuccess: () => {
          setOpenDeleteDialog(false);
          setOpen(false);
        },
      }
    );
  }, [deleteWebhookMutation, integration.id]);

  return (
    <>
      <Menu
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        target={
          <IconButton
            variant="text gray"
            active={open}
          >
            <TreeDotsIcon />
          </IconButton>
        }
        menuClassName="tw-relative tw-overflow-hidden"
      >
        <List className="tw-py-2">
          <ListItem onClick={handleOpenEdit}>
            <EditIcon className="tw-fill-theme-900" />
            {t("Edit")}
          </ListItem>
          <ListSeparator />
          <ListItem onClick={handleOpenDelete}>
            <TrashIcon className="tw-fill-theme-900" />
            {t("Delete")}
          </ListItem>
        </List>
      </Menu>
      {openEditDialog ? (
        <WebhookFormDialog
          integration={integration}
          open={openEditDialog}
          onClose={handleCloseEdit}
        />
      ) : null}
      {openDeleteDialog ? (
        <ConfirmDialog
          open={openDeleteDialog}
          dialogTitle={t("Delete Webhook")}
          dialogContent={t("Webhook will be deleted permanently.")}
          confirmBtnText={t("Delete")}
          cancelBtnText={t("Cancel")}
          onConfirm={handleDelete}
          onCancel={handleCloseDelete}
        />
      ) : null}
    </>
  );
};

WebhookIntegrationOptions.propTypes = {
  integration: PropTypes.object,
};
